import { useMemo } from 'react'
import { useDataValue, useDataChange } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let event_id = useDataValue({
    context: 'automation',
    path: 'event_id',
    viewPath: props.viewPath,
  })
  let selected_phone = useDataValue({
    context: 'event_action',
    path: 'data.sms_template.from',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'event_action',
    path: 'data.sms_template.from',
    viewPath: props.viewPath,
  })
  return useMemo(() => {
    if (!data) return data
    let default_number = data.comms_defaults[0]?.sender_id ?? null

    // if it is a new automation and default email is there. use that as default
    if (!event_id && default_number !== null && !selected_phone) {
      change('DEFAULT')
    }

    if (data.comms_mobile_numbers_outbound.length === 0) {
      change(null)
      return data.comms_mobile_numbers_outbound
    }

    return data.comms_mobile_numbers_outbound.map(number => ({
      id: number.id === default_number ? 'DEFAULT' : number.id,
      text:
        number.id === default_number
          ? `Default (${number.number})`
          : number.number,
    }))
  }, [data])
}
